import React, {useEffect, useState} from "react"
import {connect, useDispatch, useSelector} from "react-redux"
import withRouter from "../../components/Common/withRouter";
import {Button, Card, CardBody, CardImg, Col, Form, FormFeedback, Input, Label, Row} from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"

import {useFormik} from "formik"
import * as Yup from "yup"
import {createCompany, getCompanyDetails, updateCompany} from "../../store/Company/actions";
import {Link, useParams} from "react-router-dom";
import Remove from "../../assets/images/remove.png";
import {deleteFile} from "../../store/Files/actions";
import IMG_file_icon from "../../assets/images/IMG_file_icon.svg.png";
import PDF_file_icon from "../../assets/images/PDF_file_icon.svg.png";
import Dropzone from "react-dropzone";
import {getTokenFromLocalStorage} from "../../utils/Token";


const getFileIcon = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase(); // Получаем расширение файла
    switch (ext) {
        case 'jpg':
        case 'jpeg':
        case 'png':
            return IMG_file_icon; // Иконка для изображений
        case 'pdf':
            return PDF_file_icon; // Иконка для PDF
        case 'docx':
        case 'doc':
            return PDF_file_icon; // Иконка для Word
        default:
            return PDF_file_icon; // Иконка по умолчанию
    }
};


const Add = props => {
    const dispatch = useDispatch()
    const {id} = useParams();


    const [selectedFilesErr3, setSelectedFilesErr3] = useState(false)
    const [selectedFiles, setselectedFiles] = useState([])

    const [uploading, setUploading] = useState(false);


    const isLoading = useSelector((state) => state.Company.isLoading);
    const error = useSelector((state) => state.Company.error);
    const detail = useSelector((state) => state.Company.detail);

    const [arrayFiles, setArrayFiles] = useState([])
    useEffect(()=>{
        let item = {
            id
        }
        dispatch(getCompanyDetails(item))
    },[])


    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            _id: detail._id || '',
            email: detail.email || "",
            companyName: detail.companyName || "",
            companyId: detail.companyId || "",
            phone: detail.phone || "",
            address: detail.address || "",
        },
        validationSchema: Yup.object({
            email: Yup.string().required("შეიყვანეთ ელ-ფოსტა"),
            companyName: Yup.string().required("შეიყვანეთ სახელი"),
            companyId: Yup.string().required("შეიყვანეთ კომპანის საიდენტიფიკაციო ნომერი"),
            phone: Yup.string().required("შეიყვანეთ ტელეფონი"),
            address: Yup.string().required("შეიყვანეთ მისამართი"),
        }),

        onSubmit: async (values) => {
            try {
                const item = {
                    id,
                    email: values.email,
                    companyName: values.companyName,
                    companyId: values.companyId,
                    phone: values.phone,
                    address: values.address,
                };

                // 1) обновляем компанию
                await dispatch(updateCompany(item));

                // 2) грузим файлы (если выбраны)
                if (selectedFiles?.length) {
                    setUploading(true);

                    for (const f of selectedFiles) {
                        await uploadFileForCompany({ companyId: id, file: f });
                    }

                    // очистим выбранные
                    setselectedFiles([]);
                    setSelectedFilesErr3(false);
                }

                // 3) обновим detail, чтобы увидеть новые файлы
                dispatch(getCompanyDetails({ id }));
            } catch (e) {
                console.error(e);
            } finally {
                setUploading(false);
            }
        }



        /*        onSubmit: (values) => {
                    //validation.values.nameEn
                    let item = {
                        id: id,
                        email: values.email,
                        companyName: values.companyName,
                        companyId: values.companyId,
                        phone: values.phone,
                        address: values.address,
                    }
                   dispatch(updateCompany(item))
                   // validation.resetForm();
                }*/
    })


    const uploadFileForCompany = async ({ companyId, file }) => {
        const token = getTokenFromLocalStorage(); // твоя функция

        const formData = new FormData();
        formData.append("file", file);

        const resp = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/api2/upload/files/${companyId}/company`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
                body: formData
            }
        );

        const data = await resp.json().catch(() => ({}));
        if (!resp.ok) {
            throw new Error(data?.error || "Upload failed");
        }
        return data;
    };




    useEffect(() => {
        setArrayFiles(Array.isArray(detail?.files) ? detail.files : []);
    }, [detail?.files]);


    const handleRemove = async (fileId) => {
        try {
            await dispatch(deleteFile({ id: fileId }));
            dispatch(getCompanyDetails({ id }));
        } catch (e) {
            console.error(e);
        }
    };




    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }

    function handleAcceptedFiles(files) {
        files.map(file => {
                if (file.size >= 3022117) {
                    setSelectedFilesErr3(true)
                    setselectedFiles([])
                    return false
                } else {
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        formattedSize: formatBytes(file.size),
                    })
                }
            }
        )
        setselectedFiles(files)
    }



    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title={process.env.REACT_APP_PROJECT_NAME}
                                 breadcrumbItem="ახალი კომპანიის დამატება"/>

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <Form
                                        className="form-horizontal"
                                        onSubmit={(e) => {
                                            e.preventDefault()
                                            validation.handleSubmit()
                                            return false
                                        }}
                                    >

                                        <Row>

                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">კომპანიის სახელი</Label>
                                                    <Input
                                                        name="companyName"
                                                        className="form-control"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.companyName || ""}
                                                        invalid={
                                                            validation.touched.companyName && validation.errors.companyName ? true : false
                                                        }
                                                    />
                                                    {validation.touched.companyName && validation.errors.companyName ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.companyName}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>

                                            <Col md="12">

                                            </Col>
                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">ელ-ფოსტა</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                            validation.touched.email && validation.errors.email ? true : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>


                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">კომპანიის საიდენტიფიკაციაა</Label>
                                                    <Input
                                                        name="companyId"
                                                        className="form-control"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.companyId || ""}
                                                        invalid={
                                                            validation.touched.companyId && validation.errors.companyId ? true : false
                                                        }
                                                    />
                                                    {validation.touched.companyId && validation.errors.companyId ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.companyId}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>

                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">კომპანის ტელეფონის ნომერი</Label>
                                                    <Input
                                                        name="phone"
                                                        className="form-control"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.phone || ""}
                                                        invalid={
                                                            validation.touched.phone && validation.errors.phone ? true : false
                                                        }
                                                    />
                                                    {validation.touched.phone && validation.errors.phone ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.phone}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>

                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label className="form-label">კომპანის მისამართი</Label>
                                                    <Input
                                                        name="address"
                                                        className="form-control"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.address || ""}
                                                        invalid={
                                                            validation.touched.address && validation.errors.address ? true : false
                                                        }
                                                    />
                                                    {validation.touched.address && validation.errors.address ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.address}</FormFeedback>
                                                    ) : null}
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Dropzone
                                                        accept={{
                                                            "image/*": [".png", ".jpg", ".jpeg", ".gif", ".webp"],
                                                            "application/pdf": [".pdf"],
                                                        }}
                                                        multiple
                                                        onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}
                                                        onDropRejected={(fileRejections) => {
                                                            // покажем ошибку и, например, имена отклонённых файлов
                                                            setSelectedFilesErr3(true);
                                                            console.warn(
                                                                "Rejected:",
                                                                fileRejections.map(r => ({ name: r.file.name, errors: r.errors }))
                                                            );
                                                        }}
                                                    >
                                                        {({ getRootProps, getInputProps }) => (
                                                            <div className="dropzone">
                                                                <div
                                                                    className="dz-message needsclick"
                                                                    style={{ fontSize: "17px" }}
                                                                    {...getRootProps()}
                                                                >
                                                                    <input {...getInputProps()} />
                                                                    <p>ატვირთეთ ფაილები: PDF, Excel, Word, TXT ან PNG</p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                    {
                                                        selectedFilesErr3
                                                            ? <span style={{color: 'red'}}><i>ატვირთეთ ფაილები: PDF, Excel, Word, TXT ან PNG</i></span>
                                                            : null
                                                    }
                                                    <div className="dropzone-previews mt-3" id="file-previews">
                                                        {selectedFiles.map((f, i) => {
                                                            return (
                                                                <Card
                                                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                                    key={i + "-file"}
                                                                >
                                                                    <div className="p-2">
                                                                        <Row className="align-items-center">
                                                                            {/* <Col className="col-auto">
                                                                                <img
                                                                                    data-dz-thumbnail=""
                                                                                    height="80"
                                                                                    className="avatar-sm rounded bg-light"
                                                                                    alt={f.name}
                                                                                    src={f.preview}
                                                                                />
                                                                            </Col>*/}
                                                                            <Col>
                                                                                <Link
                                                                                    to="#"
                                                                                    className="text-muted font-weight-bold"
                                                                                >
                                                                                    {f.name}
                                                                                </Link>
                                                                                <p className="mb-0">
                                                                                    <strong>{f.formattedSize}</strong>
                                                                                </p>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </Card>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg="6">
                                                <button
                                                    className="btn btn-primary w-100 waves-effect waves-light"
                                                    type="submit"
                                                    disabled={uploading}
                                                >
                                                    {uploading ? "Uploading..." : "დამახსოვრება"}
                                                </button>

                                            </Col>
                                        </Row>



                                        {detail?._id && Array.isArray(arrayFiles) && arrayFiles.length > 0 && (
                                            <Row className="mt-4">
                                                <Col xs="12" className="mb-2">
                                                    <strong>Files</strong>
                                                </Col>

                                                <Col xs="12">
                                                    <Row>
                                                        {arrayFiles.map((file) => (
                                                            <Col key={file._id} lg="2" md="3" sm="4" xs="6" className="mb-3">
                                                                <Card className="mb-2 position-relative">
                                                                    <div style={{ position: "absolute", top: 8, right: 8, zIndex: 2 }}>
                                                                        <img
                                                                            onClick={() => handleRemove(file._id)}
                                                                            style={{ height: 24, cursor: "pointer" }}
                                                                            src={Remove}
                                                                            alt="remove"
                                                                        />
                                                                    </div>

                                                                    <CardImg
                                                                        top
                                                                        className="img-fluid"
                                                                        src={getFileIcon(file.name)}
                                                                        alt={file.name}
                                                                    />
                                                                </Card>

                                                                <a
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    href={`${process.env.REACT_APP_UPLOADER_SERVER_URL}${file.url}`}
                                                                >
                                                                    <i>{file.name}</i>
                                                                </a>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Col>
                                            </Row>
                                        )}






                                    </Form>

                                </CardBody>
                            </Card>

                        </Col>
                    </Row>

                </div>
            </div>
        </React.Fragment>

    )
}

export default withRouter(Add)
